import React from "react";
import { Link } from "react-router-dom";
import useInView from "./useInView";

// Book -> Approve -> Play, as three columns.
//
// --- what this replaced, and why -----------------------------------------
//
// This was a scroll-driven sticky sequence: three steps scrolling past a
// pinned column that swapped between three demo interfaces, wired to an
// IntersectionObserver. It was the most technically interesting thing on the
// page and it was costing three viewport heights to say something that fits
// in nine words a step.
//
// The homepage's job for this idea is "there are three steps and none of them
// is a surprise". Anyone who wants the interfaces is already convinced enough
// to click through to How it works, which is where the detail belongs and
// where somebody is actually reading rather than scanning.
//
// The step copy is kept almost verbatim -- it was good, and it was never the
// reason the section was long.

const STEPS = [
    {
        n: "01",
        title: "Book",
        body: "Choose your locations and dates. The rate on the listing is the rate you pay.",
    },
    {
        n: "02",
        title: "Approve",
        body: "The host approves it for their business. A slot can only be sold once.",
    },
    {
        n: "03",
        title: "Play",
        body: "Your ad runs on the screens and hours you booked, and each play is reported.",
    },
];

export default function BookingStory() {
    const [ref, inView] = useInView({ threshold: 0.2 });

    return (
        <section className={"bs" + (inView ? " is-in" : "")} ref={ref}>
            <div className="bs__inner">
                {/* The headline is the argument and the three steps are the
                    proof, which is why this section carries the "why" rather
                    than getting one of its own. It used to read "How a booking
                    works" -- a label for a list, which is a thing you skip. */}
                <header className="bs__head">
                    <h2 className="bs__title">
                        The real world shouldn’t be this hard to advertise in.
                    </h2>
                    <p className="bs__lede">
                        Online, you can launch an ad in minutes. Doing it down the
                        street shouldn’t take a billboard budget and a dozen phone
                        calls.
                    </p>
                </header>

                <ol className="bs__steps">
                    {STEPS.map((step, i) => (
                        <li className="bs__step" key={step.n} style={{ "--i": i }}>
                            <span className="bs__n" aria-hidden="true">{step.n}</span>
                            <h3 className="bs__step-title">{step.title}</h3>
                            <p className="bs__step-body">{step.body}</p>
                        </li>
                    ))}
                </ol>

                <div className="bs__cta">
                    <Link to="/how-it-works" className="wb-btn wb-btn--secondary">
                        See how WallBurst works →
                    </Link>
                </div>
            </div>
        </section>
    );
}
